var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Artikel toevoegen")]),_c('div',{staticClass:"content"},[_c('create-article-wrapper',{attrs:{"publisher-name":_vm.publisherName}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }